import { render, staticRenderFns } from "./InvalidPropertiesList.vue?vue&type=template&id=301d1470"
import script from "./InvalidPropertiesList.vue?vue&type=script&lang=js"
export * from "./InvalidPropertiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports